/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-03-20 16:39:47
 * @FilePath: \qctsw-vue\packages\app\src\logic\home\banner.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { HomeBannerArticles, HomeBannerComplaint, HomeBannerData } from '@/server/types'
import { LOAD_STATE } from '@/shared/types'
import { getHomeBannerDataApi } from '@/server'

export function logicHomeBanner() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const bannerData = ref<{
    banner: HomeBannerArticles[]
    news: HomeBannerArticles[]
    complaint: HomeBannerComplaint
  }>({
    banner: [],
    news: [],
    complaint: {
      complainTotal: 0,
      dayTotalComplain: 0,
      totalCollective: 0,
      totalMore: 0,
      exchangeCarTotal: 0,
      complainMoney: 0,
    },
  })

  function formatBannerData(data?: HomeBannerData) {
    if (!data)
      return
    const banner = data.bannres
    let news = []
    for (const item in data.articles)
      news.push(data.articles[item])

    news = news.slice(0, 12)
    const complaint = data.complain

    bannerData.value = {
      banner,
      news,
      complaint,
    }
  }

  async function getHomeBannerData() {
    const res = await useLoadState({
      key: `HOME_BANNER`,
      state,
      fn: getHomeBannerDataApi,
    })

    formatBannerData(res?.data)
  }

  return {
    state,
    bannerData,
    getHomeBannerData,
  }
}
